import React from "react";
import { Modal, Button, CloseButton } from "react-bootstrap";

const GenerateQRModal = ({
    show,
    close,
    onConfirm,
    loading,
}) => {
    return (
        <Modal show={show} onHide={close} centered>
            <Modal.Header>
                <Modal.Title
                    style={{ fontSize: "16px", fontWeight: 600 }}
                >
                    Confirm QR Generation
                </Modal.Title>

                <CloseButton onClick={close} variant="black" />
            </Modal.Header>

            <Modal.Body
                style={{
                    position: "relative",
                    minHeight: "85px",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "15px",
                }}
            >
                Are you sure you want to generate QR code?
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={close}
                    disabled={loading}
                >
                    Cancel
                </Button>

                <Button
                    variant="primary"
                    onClick={onConfirm}
                    disabled={loading}
                >
                    {loading ? "Generating..." : "Generate QR"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default GenerateQRModal;